import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a17f517"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }

import { reactive, ref } from 'vue'
import { FormInstance, FormRules } from 'element-plus'
import useFormRequest from '@/composables/useFormRequest'
import { iRegisterForm } from '@/types/common/requests'
import { register } from '@/store/actions/auth'
import { UserRoleLabels } from '@/helpers/labels'
import VueTurnstile from 'vue-turnstile'

interface iRegisterFormState extends iRegisterForm {
  confirmPassword: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationForm',
  emits: ['create'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const formRef = ref<FormInstance>()
const formRequest = useFormRequest<iRegisterFormState>()

const turnstileSiteKey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY

const searchQuery = location.search.substring(1).split('&').map(c => c.split('=')) as unknown as Iterable<readonly [string, string]>
const refCode: string = (location.search ? (new Map<string, string>(searchQuery)).get('ref') : undefined) || ''

const form = reactive<iRegisterFormState>({
  role: 'partner',
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
  ref: refCode,
  captcha: ''
})

const rules = reactive<FormRules<iRegisterFormState>>({
  name: [
    { required: true, message: 'Обязательно для заполнения', trigger: 'blur' }
  ],
  email: [
    { required: true, message: 'Обязательно для заполнения', trigger: 'blur' },
    { type: 'email', message: 'Некорректный e-mail', trigger: 'blur' }
  ],
  password: [
    { required: true, message: 'Обязательно для заполнения', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: 'Обязательно для заполнения', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== form.password) {
          callback(new Error('Пароли не совпадают'))
        } else {
          callback()
        }
      }
    }
  ]
})

const handleSubmit = async () => {
  await formRef.value?.validate(valid => {
    if (valid) {
      formRequest.tryRequest(async () => {
        await register(form)
        emit('create', form.email)
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, { class: "card" }, {
            header: _withCtx(() => [
              _createTextVNode("Регистрация")
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                model: form,
                rules: rules,
                ref_key: "formRef",
                ref: formRef,
                "status-icon": "",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "role",
                    error: _unref(formRequest).state.errors.role
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.role,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.role) = $event)),
                        "default-first-option": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _unref(UserRoleLabels)['partner'],
                            value: "partner"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _unref(UserRoleLabels)['client'],
                            value: "client"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    error: _unref(formRequest).state.errors.name
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
                        placeholder: "ФИО",
                        type: "text",
                        autocomplete: "name"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    error: _unref(formRequest).state.errors.email
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
                        placeholder: "E-mail",
                        type: "text",
                        autocomplete: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    error: _unref(formRequest).state.errors.password
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.password) = $event)),
                        placeholder: "Пароль",
                        type: "password",
                        autocomplete: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, { prop: "confirmPassword" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.confirmPassword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.confirmPassword) = $event)),
                        placeholder: "Повторите пароль",
                        type: "password",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "captcha",
                    error: _unref(formRequest).state.errors.captcha,
                    class: "captcha-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VueTurnstile), {
                        modelValue: form.captcha,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.captcha) = $event)),
                        "site-key": _unref(turnstileSiteKey),
                        theme: "light",
                        size: "flexible"
                      }, null, 8, ["modelValue", "site-key"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          "native-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Зарегистрироваться")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _unref(formRequest).state.pending]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})